export default "__VITE_ASSET__Dul49CMA__"